var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "large-modal" },
            [
              _c(
                "b-btn",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.modallg",
                      modifiers: { modallg: true }
                    }
                  ],
                  attrs: { variant: "primary" }
                },
                [_vm._v("Large modal")]
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                { attrs: { id: "modallg", size: "lg", title: "Large Modal" } },
                [
                  _vm._v(
                    "\n                    We use cookies to improve your website experience\n\n                    "
                  ),
                  _c("b-button", [_vm._v("Learn More")]),
                  _vm._v(" "),
                  _c("b-button", [_vm._v("OK, Thanks")])
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Modals")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20180276", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20180276","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals.vue
// module id = null
// module chunks = 